<template>
  <v-footer id="core-footer"
            height="auto"
            class="py-">


    <v-container fluid>
      <!--<v-layout row>
        <v-flex xs6 >
          <v-card dark tile flat color="error">
            <v-card-text>#1</v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs6>
          <v-card dark tile flat color="red darken-4">
            <v-card-text>#2</v-card-text>
          </v-card>
        </v-flex>
      </v-layout>-->
      <v-layout row>
        <v-flex xs6 md2>
          <v-card dark tile flat>
            <v-card-text>
              <!--<v-img :src="algebraLogo"
                     width="110"
                     height="110"
                     contain />
              <span class="algebra-text">ALGEBRA</span>-->
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs6 md3>
          <v-card tile flat>
            <v-card-text class="ma-0 pa-0">

            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs6 md3>
          <v-card dark tile flat>
            <v-card-text class="ma-0 pa-0">
              <!--&copy; ALGEBRA-->
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs6 md3>
          <v-card tile flat class="ma-0 pa-0">
            <v-card-text class="ma-0 pa-0">
              
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      
    </v-container>

    <!--<v-img :src="algebraLogo"
           width="110"
           height="110"
           contain
           class="ml-3" />
    <v-label class="white" color="tertiary"> <h4>ALGEBRA</h4> </v-label>-->

  </v-footer>
</template>

<script>
  export default {
    data: () => ({
      algebraLogo: '/assets/images/logos/AlgebraLogo.png',
      links: [
        { name: 'Home', Link: '/dashboard' },
        { name: 'Creative Tim', Link: 'https://www.creative-tim.com' },
        { name: 'About Us', Link: 'https://creative-tim.com/presentation' },
        { name: 'Blog', Link: 'https://blog.creative-tim.com' }
      ]
    })
  }
</script>

<style>
  #core-footer {
    z-index: 0;
  }

  .algebra-text {
    font-size: 1.6em;
    font-weight: bold;
    font-family: stolzl-thin;
    color: deepskyblue !important;
  }
</style>



// WEBPACK FOOTER //
// VueSrc/Common/Components/materialcomponents/components/core/Footer.vue